import { render, staticRenderFns } from "./FirebaseStoragePicture.vue?vue&type=template&id=6445a3c0"
import script from "./FirebaseStoragePicture.vue?vue&type=script&lang=js"
export * from "./FirebaseStoragePicture.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports